// extracted by mini-css-extract-plugin
export default {"container":"Container_container__Bmbi2","container__content":"Container_container__content__SGqhl","standard":"Container_standard__O1wgr","large":"Container_large__gc3qW"};